<script>
import View from 'ol/View'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import {XYZ} from "ol/source";
import {getPointResolution, Projection, useGeographic} from "ol/proj";
import {loadOrchardMap} from "@/util/api";

import 'ol/ol.css'
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {all} from "ol/loadingstrategy";
import Geolocation from 'ol/Geolocation';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import {default as OSMXML} from "ol/format/OSMXML";
import {Fill, Icon, Stroke, Style, Text, Circle as CircleStyle} from "ol/style";
import {Select} from "ol/interaction";
import {never} from "ol/events/condition";
import {Control, ScaleLine, defaults as controlDefaults} from "ol/control";
import mapApi from '@/util/map-api.json'
import {Overlay} from "ol";



class LocateControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'29\' height=\'29\' viewBox=\'0 0 20 20\'>\n' +
      '  <path\n' +
      '    d=\'M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7\'/>\n' +
      '  <circle cx=\'10\' cy=\'10\' r=\'2\'/>\n' +
      '</svg>\n';

    const element = document.createElement('div');
    element.className = 'locate-me ol-unselectable ol-control';
    element.appendChild(button);
    super({
      element: element,
      target: options.target,
    });
    this.geolocation = opt_options['geolocation'];
    this.geolocation.on('change:tracking', this.trackingChanged.bind(this), false)
    button.addEventListener('click', this.handleLocate.bind(this), false);
    console.log("Created LocateControl with " + element)
  }

  trackingChanged() {
    console.log("Tracking: " + this.geolocation.getTracking())
    this.element.classList.toggle('tracking', this.geolocation.getTracking());
  }

  handleLocate() {
    let tracking = !this.geolocation.getTracking()
    console.log("LocateControl clicked " + tracking)
    this.geolocation.setTracking(tracking);
  }
}

class OpenMapControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'29\' height=\'29\' viewBox=\'0 0 128 128\' >\n' +
      '<g id="Regular-S" transform="matrix(1 0 0 1 16 100)">\n' +
      //Map '<path d="M14.502 1.46484C15.5762 1.46484 16.6016 1.12305 17.9688 0.390625L37.3047-9.96094L58.6426 1.75781C60.1074 2.53906 61.6699 2.92969 63.1836 2.92969C64.5996 2.92969 66.0156 2.58789 67.1387 1.95312L87.3047-9.375C89.7461-10.7422 90.918-12.8418 90.918-15.5762L90.918-67.0898C90.918-70.166 89.209-71.875 86.1328-71.875C85.1074-71.875 84.0332-71.5332 82.666-70.8008L62.3535-59.4238L41.3574-72.3145C40.2344-72.998 38.8672-73.3398 37.5-73.3398C36.084-73.3398 34.668-72.998 33.4961-72.3145L13.3789-60.9863C10.8887-59.6191 9.76562-57.5195 9.76562-54.834L9.76562-3.32031C9.76562-0.244141 11.4746 1.46484 14.502 1.46484ZM34.4727-16.9434L17.8223-7.86133C17.627-7.76367 17.4316-7.66602 17.2852-7.66602C16.9434-7.66602 16.7969-7.86133 16.7969-8.20312L16.7969-53.0273C16.7969-53.9551 17.1875-54.6387 18.0664-55.1758L33.1055-63.8184C33.5938-64.1113 34.0332-64.3555 34.4727-64.6484ZM41.5527-16.2109L41.5527-63.6719C41.9434-63.4277 42.3828-63.1836 42.7734-62.9395L59.1309-52.9785L59.1309-6.54297C58.5449-6.88477 57.959-7.17773 57.373-7.51953ZM66.1621-5.71289L66.1621-53.418L82.8613-62.5488C83.0566-62.6465 83.252-62.7441 83.3984-62.7441C83.6914-62.7441 83.8379-62.5488 83.8379-62.207L83.8379-17.334C83.8379-16.4062 83.4961-15.7227 82.6172-15.1855L68.0176-6.78711C67.4316-6.39648 66.7969-6.05469 66.1621-5.71289Z"/>' +
      //Car '<path d="M28.6621-46.7285C28.3203-45.3125 28.9551-44.8242 30.4199-44.9219C36.377-45.3125 43.6523-45.7031 55.5176-45.7031C67.334-45.7031 74.6582-45.3125 80.6152-44.9219C82.0801-44.8242 82.7148-45.3125 82.373-46.7285C81.4941-50.4883 79.7363-55.9082 78.5156-58.0078C77.5879-59.668 76.6113-60.2539 74.9023-60.498C72.168-60.8887 66.0156-61.1816 55.5176-61.1816C44.9707-61.1816 38.8672-60.8887 36.1328-60.498C34.4238-60.2539 33.4473-59.668 32.4707-58.0078C31.25-55.9082 29.4922-50.4883 28.6621-46.7285ZM27.9297-20.5566C31.5918-20.5566 34.375-23.3398 34.375-27.002C34.375-30.6641 31.5918-33.4473 27.9297-33.4473C24.2676-33.4473 21.4844-30.6641 21.4844-27.002C21.4844-23.3398 24.2676-20.5566 27.9297-20.5566ZM45.2148-22.2656L65.8203-22.2656C68.5547-22.2656 70.459-24.2188 70.459-26.9531C70.459-29.6875 68.5547-31.5918 65.8203-31.5918L45.2148-31.5918C42.4805-31.5918 40.5762-29.6875 40.5762-26.9531C40.5762-24.2188 42.4805-22.2656 45.2148-22.2656ZM83.1055-20.5566C86.7676-20.5566 89.5508-23.3398 89.5508-27.002C89.5508-30.6641 86.7676-33.4473 83.1055-33.4473C79.4434-33.4473 76.6602-30.6641 76.6602-27.002C76.6602-23.3398 79.4434-20.5566 83.1055-20.5566ZM55.5176-10.3027C68.5547-10.3027 85.6445-10.9375 92.9199-11.7676C98.291-12.3535 101.27-15.3809 101.27-20.4102L101.27-27.1484C101.27-33.4961 100.049-37.207 96.3379-41.9922L93.1641-46.1426C91.748-53.0273 89.209-60.2539 87.8906-63.0859C85.8398-67.3828 81.8359-70.1172 76.5625-70.8008C73.9746-71.1426 65.7227-71.3379 55.5176-71.3379C45.3125-71.3379 37.0117-71.0938 34.4727-70.8008C29.1992-70.166 25.1953-67.3828 23.1445-63.0859C21.8262-60.2539 19.2871-53.0273 17.8711-46.1426L14.6973-41.9922C10.9863-37.207 9.76562-33.4961 9.76562-27.1484L9.76562-20.4102C9.76562-15.3809 12.7441-12.3535 18.1152-11.7676C25.3906-10.9375 42.4805-10.3027 55.5176-10.3027ZM55.5176-15.918C42.2852-15.918 25.6348-16.5039 19.7266-17.2363C16.5039-17.6758 15.4297-19.3848 15.4297-22.2656L15.4297-27.1484C15.4297-32.373 16.2598-34.7168 19.1406-38.5254L23.1445-43.7012C24.0723-48.9746 26.5625-56.8359 28.2715-60.498C29.4434-63.0371 31.7871-64.6484 35.1562-65.0391C37.6465-65.332 45.2637-65.7227 55.5176-65.7227C65.7715-65.7227 73.584-65.332 75.7812-65.0391C79.2969-64.5996 81.543-62.9883 82.7637-60.498C84.4727-56.8359 86.9141-48.9746 87.8906-43.7012L91.8457-38.5254C94.7754-34.7168 95.6055-32.373 95.6055-27.1484L95.6055-22.2656C95.6055-19.3848 94.4824-17.627 91.3086-17.2363C85.4004-16.5039 68.7012-15.918 55.5176-15.918ZM16.8457 0.390625L21.4355 0.390625C24.3652 0.390625 26.6113-1.80664 26.6113-4.6875L26.6113-14.2578L11.7188-16.4551L11.7188-4.6875C11.7188-1.80664 13.9648 0.390625 16.8457 0.390625ZM89.5996 0.390625L94.1406 0.390625C97.0703 0.390625 99.3164-1.80664 99.3164-4.6875L99.3164-16.4551L84.4238-14.2578L84.4238-4.6875C84.4238-1.80664 86.6699 0.390625 89.5996 0.390625Z"/>\n' +
      '<path d="M22.5098 7.51953C29.5898 7.51953 35.3027 1.85547 35.3027-5.22461C35.3027-12.2559 29.5898-17.9199 22.5098-17.9199C15.5273-17.9199 9.81445-12.2559 9.81445-5.22461C9.81445 1.85547 15.5273 7.51953 22.5098 7.51953Z"/>\n' +
      '<path d="M54.834-68.7988L30.3711-68.7988C17.7246-68.7988 9.76562-62.207 9.76562-51.7578C9.76562-41.0156 17.5293-34.1309 32.9102-32.5195L54.1992-30.3223C65.8203-29.1016 71.3867-24.9512 71.3867-18.7012C71.3867-12.5488 66.1621-8.69141 57.8125-8.69141L57.0312-8.69141L57.0312-14.1602C57.0312-17.2363 54.834-18.6035 52.6367-16.7969L41.2598-7.61719C39.4043-6.15234 39.4531-4.29688 41.2598-2.88086L52.6855 6.25C54.834 8.00781 57.0312 6.64062 57.0312 3.61328L57.0312-1.66016L57.8125-1.66016C70.459-1.66016 78.418-8.25195 78.418-18.7012C78.418-29.4434 70.7031-36.3281 55.2734-37.9395L34.0332-40.1367C22.4121-41.3574 16.7969-45.5078 16.7969-51.7578C16.7969-57.9102 22.0215-61.7676 30.3711-61.7676L54.834-61.7676Z"/>\n' +
      '<path d="M65.6738-52.5391C72.7051-52.5391 78.418-58.2031 78.418-65.2832C78.418-72.3145 72.7051-77.9785 65.6738-77.9785C58.6426-77.9785 52.9785-72.3145 52.9785-65.2832C52.9785-58.2031 58.6426-52.5391 65.6738-52.5391ZM65.6738-59.375C62.4023-59.375 59.8145-61.9629 59.8145-65.2832C59.8145-68.6035 62.4023-71.1426 65.6738-71.1426C68.9941-71.1426 71.582-68.6035 71.582-65.2832C71.582-61.9629 69.043-59.375 65.6738-59.375Z"/>\n'+
      '</g>\n' +
      '</svg>';

    const element = document.createElement('div');
    element.className = 'open-map ol-unselectable ol-control';

    element.appendChild(button);
    super({
      element: element,
      target: options.target,
    });
    this.orchard_map = opt_options['orchard_map'];
    this.orchard_map.$on('change:kpin', this.handleKpinChange.bind(this))
    element.style.display = this.orchard_map.kpin ? '' : 'none'
    // TODO disable when no orchard is selected
    button.addEventListener('click', this.handleClick.bind(this), false);
    console.log("Created OpenMapControl with " + element)
  }
  handleKpinChange(new_kpin) {
    this.element.style.display = new_kpin ? '' : 'none'
  }
  handleClick() {
    let url = this.orchard_map.getOrchardMapUrl()
    console.log("OpenMapControl clicked. Open ", url)
    if (url) {
      window.open(url, '_blank')
    }
  }
}

export default {
  name: 'OrchardMap',
  components: {},
  data() {
    return {
      map: null,
      orchardSource: null,
      overviewSource: null,
      basemapLayers: [],
      blocks: {},
      rows: {},
      located: false
    }
  },
  props: {
    companies: {
      type: Array,
      default() { return []}
    },
    company: {
      default: null
    },
    kpin: {
      default: null
    },
    active_block: {
      type: String,
      default: null
    },
    active_row: {
      type: String,
      default: null
    },
    bayColor: {
      type: Function,
      default: (_) => "#ff000077"
    },
    hovered: {
      type: Array,
      default() {
        return []
      }
    },
    selected: {
      type: Array,
      default() {
        return []
      }
    },
    geolocation: {
      type: Object,
      default: null
    },
    autoCenter: {
      type: Boolean,
      default: false
    },
    autoCenterMode: {
      type: String,
      default: 'point'
    }
  },
  watch: {
    companies(_) {
      this.overviewSource.refresh()
    },
    kpin(new_kpin) {
      this.orchardSource.refresh()
      this.$emit('change:kpin', new_kpin)
    },
    autoCenter(new_value, old_value) {
      console.log("AutoCenter changed", old_value, new_value)
      if (!old_value && new_value) {
        this.autoCenterMap(this.geolocation)
      }
    },
    autoCenterMode(new_value, old_value) {
      if (new_value !== old_value) {
        this.autoCenterMap(this.geolocation)
      }
    },
    active_row(_) {
      this.autoCenterMap(this.geolocation)
    },
    rows(_) {
      this.autoCenterMap(this.geolocation)
    },
    active_block(_) {
      this.autoCenterMap(this.geolocation)
    },
    blocks(_) {
      this.autoCenterMap(this.geolocation)
    },
    geolocation(loc) {
      if (loc) {
        const heading = loc.heading
        if (heading === null || heading === undefined) {
          this.$refs.geolocation_marker.src = '/img/icons/geolocation_marker.png'
          this.$refs.geolocation_marker.style.rotate = undefined
        } else {
          this.$refs.geolocation_marker.style.rotate = `${heading}deg`
          this.$refs.geolocation_marker.src = '/img/icons/geolocation_marker_heading.png'
        }
        if (this.autoCenter && this.autoCenterMode === 'point') {
          this.autoCenterMap(loc)
        }

        this.marker.setPosition(loc.position);
        // TODO change image if heading is not available / speed is low
      } else {
        // TODO hide marker
        this.marker.setPosition(undefined);
      }
    }
  },
  methods: {
    getOrchardMapUrl() {
      if (this.$root.orchard != null) {
        let entry = this.$root.orchard.entry || this.$root.orchard.center
        // return `https://www.google.com/maps/@?api=1&map_action=map&center=${entry.lat},${entry.lon}&zoom=17&basemap=roadmap&layer=traffic`
        return `https://www.google.com/maps/dir/?api=1&destination=${entry.lat},${entry.lon}&travelmode=driving&dir_action=navigate`
      }
      return null
    },
    autoCenterMap(loc) {
      if (this.autoCenter) {
        if (this.autoCenterMode === 'point' && loc && loc.position) {
          console.log("Auto-centering on", loc.position)
          this.map.getView().setCenter(loc.position)
          return true
        }
        if (this.autoCenterMode === 'block' && this.active_block) {
          let block_feature = this.blocks[this.active_block]
          if (block_feature) {
            console.log("Auto-centering on", this.active_block)
            this.map.getView().fit(block_feature.getGeometry(), {padding: Array(4).fill(5)})
            return true
          } else {
            console.log("No block", this.active_block, this.blocks)
          }
          return false
        }
        if (this.autoCenterMode === 'row' && this.active_block && this.active_row) {
          let row_feature = this.rows[this.active_block + "!!" + this.active_row]
          if (row_feature) {
            console.log("Auto-centering on", this.active_block, this.active_row)
            this.map.getView().fit(row_feature.getGeometry(), {padding: Array(4).fill(5)})
            return true
          } else {
            console.log("No row", this.active_block, this.active_row, this.rows)
          }
          return false
        }
        console.log("Can't auto center", this.autoCenterMode, loc, this.active_block, this.active_row)
        return false
      } else {
        console.log("Auto center disabled", this.autoCenter, this.autoCenterMode, loc, this.active_block, this.active_row)
      }
    },
    refreshColors() {
      return this.orchardSource.changed()
    },
    drawOnCanvas(canvas, include_basemap=false) {
      let map = this.map;
      let component = this
      return new Promise((resolve, reject) => {
        let size = map.getSize();
        let viewResolution = map.getView().getResolution();

        if (!include_basemap) {
          for (let layer of this.basemapLayers) {
            map.removeLayer(layer)
          }
        }
        map.once('rendercomplete', function () {
          try {
            console.debug("map @rendercomplete")
            const context2d = canvas.getContext('2d');
            context2d.fillStyle = "white"
            context2d.fillRect(0,0, canvas.width, canvas.height);
            map.getTargetElement().querySelectorAll('.ol-layer canvas').forEach((mapCanvas) => {
                  if (mapCanvas.width > 0) {
                    const opacity = mapCanvas.parentNode.style.opacity;
                    context2d.globalAlpha = opacity === '' ? 1 : Number(opacity);
                    const transform = mapCanvas.style.transform;
                    // Get the transform parameters from the style's transform matrix
                    const matrix = transform.match(/^matrix\(([^(]*)\)$/)[1].split(',').map(Number);
                    // Apply the transform to the export map context
                    context2d.setTransform(matrix)
                    console.debug("Drawing ...")
                    context2d.drawImage(mapCanvas, 0, 0);
                  }
                }
            );
            console.debug("Finished drawing.")
            context2d.globalAlpha = 1;
            context2d.setTransform(1, 0, 0, 1, 0, 0);
            resolve(canvas)
          } catch (e) {
            reject(e)
          } finally {
            // Reset original map size
            let layers = map.getLayers()
            for (let layer of component.basemapLayers) {
              if (layers.getArray().indexOf(layer) < 0) {
                layers.insertAt(0, layer)
              }
            }
            map.setSize(size);
            map.getView().setResolution(viewResolution);
          }
        });
        // Set export size
        map.setSize([canvas.width, canvas.height]);
        const scaling = Math.min(canvas.width / size[0], canvas.height / size[1]);
        map.getView().setResolution(viewResolution / scaling);
      })
    },
    getFeaturesAtCoordinate(coordinate, viewProj = false) {
      return this.orchardSource.getFeaturesAtCoordinate(coordinate, viewProj)
    },
    loadOrchardData(extent, resolution, projection, success, failure) {
      console.debug("Loading orchard data for ", this.company, this.kpin, extent, resolution, projection)
      this.loadMap(this.orchardSource, this.company, this.kpin, resolution, projection, success, failure, true)
    },
    loadOrchardsOverview(extent, resolution, projection, success, failure) {
      console.debug("Loading overview data for ", this.companies, extent, resolution, projection)
      for (let company of this.companies) {
        this.loadMap(this.overviewSource, company, "overview", resolution, projection, success, failure, false)
      }
    },
    hashCode(value) {
      let hash = 0;
      if (value.length === 0) return hash;
      for (let i = 0; i < value.length; i++) {
        let chr = value.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
    loadMap(source, company, kpin, resolution, projection, success, failure, auto_fit) {
      if (company && kpin) {
        loadOrchardMap(company, kpin).then(value => {
          console.debug("Loaded map", company, kpin, !!value)
          const features = new OSMXML().readFeatures(value);
          console.debug("Parsed features", features.length)
          const id_base = this.hashCode(company + "!" + kpin) * 1000000
          for (const feature of features) {
            feature.setId(id_base + feature.getId())
          }
          source.addFeatures(features)
          if (auto_fit) {
            for (const feature of features) {
              if (feature.get('acuris') === "orchard") {
                this.map.getView().fit(feature.getGeometry(), {padding: Array(4).fill(50)});
              }
            }
          }

          let blocks_index = {}
          let rows_index = {}
          for (const feature of features) {
            if (feature.get('acuris') === "block") {
              blocks_index[feature.get('name')] = feature
            }
            if (feature.get('acuris') === "row") {
              rows_index[feature.get('location:block') + "!!" + feature.get('name')] = feature
            }
          }
          // console.log("Parsed blocks", Object.keys(blocks_index))
          // console.log("Parsed rows", Object.keys(rows_index))
          this.blocks = blocks_index
          this.rows = rows_index
          success(features)
        }).catch(e => {
          console.error("Failed to load map of", company, kpin, e);
          // source.removeLoadedExtent(source.extent)
          failure();
        })
      } else {
        success([])
      }
    },
    mapFeatureOrchardLocation(feature) {
      let orchardLocation = {}
      for (let prop in feature.values_) {
        if (prop.startsWith('location:')) {
          orchardLocation[prop.slice(9)] = feature.values_[prop]
        }
      }
      return orchardLocation
    },
    selectedObjectStyle(feature, resolution) {
      return this.objectStyleInternal(feature, resolution, true, false)
    },
    objectStyle(feature, resolution) {
      return this.objectStyleInternal(feature, resolution, false, false)
    },
    overviewObjectStyle(feature, resolution) {
      return this.objectStyleInternal(feature, resolution, false, true)
    },
    objectStyleInternal(feature, resolution, selected, overview) {
      const extent = feature.getGeometry().getExtent();

      const pointResolution = getPointResolution(this.map.getView().getProjection(), resolution, extent);
      let acuris_feature = feature.get('acuris')
      if (acuris_feature) {
        return this.acurisStyle(acuris_feature, feature, pointResolution, selected, overview)
      } else {
        return this.otherStyle(feature, pointResolution, overview)
      }
    },
    acurisStyle(kind, feature, resolution, selected, overview) {
      if (overview && feature.get('kpin') === this.kpin) {
        return null
      }
      switch (kind) {
        case "bay": {
          let orchardLocation = this.mapFeatureOrchardLocation(feature)
          let rowNum = parseInt(orchardLocation.row)
          let resDivisibility = Math.round(20 * (resolution - 0.2))
          let nameDivisible = resDivisibility > 1 && !feature.get('row:first') ? (rowNum % resDivisibility === 0) : true
          let firstBay = feature.get('bay:first')
          let lastBay = feature.get('bay:last')
          let nameVisible = (firstBay || lastBay) && nameDivisible && (resolution <= 0.6)
          let name = nameVisible ?  orchardLocation.row.replace(/./g, (m) => firstBay && lastBay ? `${m}\u0332\u0305` : firstBay ? `${m}\u0332` : `${m}\u0305`) : ''
          // return new Style({
          //   zIndex: 105,
          //   text: nameVisible ? this.createTextStyle(feature.get('name'), resolution * 2, 'point') : undefined,
          // })
          const even = rowNum % 2 === 0
          let color = this.bayColor(orchardLocation) || (process.env.VUE_APP_LOCAL === undefined ? undefined : (even ? 'rgba(255,0,255,0.2)' : 'rgba(255,255,0,0.2)'))
          if ((color || resolution < 0.5) && resolution < 10) {
            return new Style({
              zIndex: selected ? 200 : 100,
              fill: new Fill({
                color: color || 'rgba(127, 127, 127, 0.5)',
              }),
              stroke: selected ? new Stroke({color: 'rgb(255, 0, 0)'}) : resolution < 0.5 ? new Stroke({color: `rgba(255,255,255,${1 - resolution / 0.5})`}) : undefined,
              text: nameVisible ? this.createTextStyle(name, resolution * 3) : undefined,
            })
          } else {
            return null
          }
        }
        case "row": {
          let orchardLocation = this.mapFeatureOrchardLocation(feature)
          let active = !overview && this.active_block === orchardLocation.block && this.active_row === feature.get('name')
          return new Style({
            zIndex: 101,
            stroke: resolution < 0.5 || active ? new Stroke({
              color: active ? 'rgba(255,97,0,1)' : 'rgba(255, 255 , 255, 1)',
              width: active ? 3 : undefined,
              lineDash: active ? [5/resolution, 5/resolution] : undefined
            }) : undefined
          })
        }
        case "block": {
          let active = !overview && this.active_block === feature.get('name')
          return new Style({
            zIndex: 102,
            stroke: new Stroke({
              color: active ? 'rgba(255,97,0,1)' : 'rgba(255, 255 , 255, 1)',
              lineDash: overview ? [5/resolution, 5/resolution] : undefined,
              lineDashOffset: 0,
              width: active ? 3 : undefined
            }),
            fill: new Fill({
              color: 'rgba(255, 255 , 255, 0.01)',
            }),
            text: this.createTextStyle(feature.get('name'), resolution / 2, {color: overview ? 'grey' : 'black'}),
          })
        }
        case "row-center": {
          let nameInt = parseInt(feature.get('name'))
          let resDivisibility = Math.round(20 * (resolution - 0.3))
          let nameDivisible = resDivisibility > 1 && nameInt !== 1 ? (nameInt % nameDivisible === 0) : true
          let nameVisible = nameDivisible && (resolution <= 0.6)
          return new Style({
            zIndex: 105,
            text: nameVisible ? this.createTextStyle(feature.get('name'), resolution * 2) : undefined,
          })
        }
        case "orchard": {
          if (resolution > 6) {
            return new Style({
              zIndex: 104,
              text: this.createTextStyle(overview ? [feature.get('kpin'), feature.get('name')].join('\n') : feature.get('name'), 1, {color: overview ? 'white' : 'black'})
            })
          } else {
            return new Style({
              zIndex: 104,
              fill: new Fill({
                color: 'rgba(1, 1, 1, 0.01)',
              }),
              stroke: new Stroke({
                color: 'rgb(157, 157, 157)',
                width: 3,
                lineDash: overview ? [5 / resolution, 5 / resolution] : undefined
              }),
              text: resolution >= 1.6 ? this.createTextStyle(overview ? [feature.get('kpin'), feature.get('name')].join('\n') : feature.get('name'), resolution / 3, {color: overview ? 'lightgrey' : 'black'}) : undefined,
            })
          }
        }
        case "section":
          return null;
        case "entry":
          if (resolution > 3) {
            return null
          }
          return new Style({
            zIndex: 205,
            image: new Icon({
              src: '/static/img/icons/Barrier_gate.svg'
            })
          });
        default:
          console.log("Unhandled 'acuris' feature type", kind)
      }
    },
    otherStyle(feature, resolution) {
      if (resolution > 3) {
        // console.debug("Resolution", resolution)
        return null
      }
      let power_feature = feature.get('power')
      if (power_feature !== undefined) {
        if (power_feature === "line") {
          return new Style({
            zIndex: 200,
            stroke: new Stroke({
              color: 'black',
              width: 2,
              lineDash: [25, 10, 5, 10, 25, 10]
            })
          });
        }
      }
      let amenity_feature = feature.get('amenity')
      if (amenity_feature !== undefined) {
        // toilets, wind_machine, parking, shelter (natural, no subtype)
        if (amenity_feature === "shelter") {
          let shelter_type_feature = feature.get('shelter_type')
          if (shelter_type_feature !== undefined) {
            if (shelter_type_feature === "natural") {
              return new Style({
                zIndex: 200,
                stroke: new Stroke({
                  color: '#015e00',
                  width: 2 / resolution
                }),
              });
            }
          }
          return new Style({
            zIndex: 200,
            stroke: new Stroke({
              color: '#ffffff',
              width: 0.85
            }),
          });
        } else if (amenity_feature === "parking") {
          return new Style({
            zIndex: 205,
            image: new Icon({
              src: '/static/img/icons/Parking-16.svg'
            })
          });
        } else if (amenity_feature === "toilets") {
          return new Style({
            zIndex: 205,
            image: new Icon({
              src: '/static/img/icons/Toilets-16.svg'
            })
          });
        }
      }
      let barrier_feature = feature.get('barrier')
      if (barrier_feature !== undefined) {
        if (barrier_feature === "gate") {
          return new Style({
            zIndex: 200,
            fill: new Fill({
              color: 'rgba(1,1,1,0.01)',
            }),
            stroke: new Stroke({
              color: 'red',
              width: 0.5
            }),
          });
        } else {
          return new Style({
            zIndex: 100,
            stroke: new Stroke({
              color: '#b4b4b4',
              width: 2
            }),
          });
        }
      }
      let building_type = feature.get('building')
      if (building_type !== undefined) {
        return new Style({
          zIndex: 100,
          stroke: new Stroke({
            color: '#b4b4b4',
            width: 1
          }),
          fill: new Fill({
            color: 'rgba(145,145,145,0.53)',
          }),
        });
      }
      return null
    },
    createTextStyle(text, resolution, options= {}) {
      let offsetX = 0;
      let offsetY = 0;
      let placement = options.placement || 'point';
      let color = options.color || 'black';
      let weight = options.weight || 'bold';
      let size = options.size || '10px';
      let height = options.height || '1';
      let align = options.align || 'center';
      let baseline = options.baseline || 'middle';

      let maxAngle = 90 / 180 * Math.PI;
      let overflow = true;
      let rotation = 0.0;
      let font = weight + ' ' + size + '/' + height + ' ' + 'Verdana';

      return new Text({
        textAlign: align === '' ? undefined : align,
        textBaseline: baseline,
        font: font,
        text: text,
        fill: new Fill({color: color}),

        offsetX: offsetX,
        offsetY: offsetY,
        placement: placement,
        maxAngle: maxAngle,
        overflow: overflow,
        rotation: rotation,
        scale: [1 / resolution, 1 / resolution]
      });
    },
  },
  mounted() {
    // this is where we create the OpenLayers map
    useGeographic()
    const component = this
    this.orchardSource = new VectorSource({
      attributions: "Orchard: <a href=\"https://acurissystems.com\"> Acuris Systems</a>",
      loader: this.loadOrchardData,
      strategy: all
    })
    this.overviewSource = new VectorSource({
      loader: this.loadOrchardsOverview,
      strategy: all
    })
    this.basemapLayers = [
    //   new TileLayer({
    //   source: new XYZ({
    //     attributions: "BoP 2024 Draft Basemap: <a href=\"https://basemaps.linz.govt.nz\">&copy; CC BY 4.0 LINZ</a>",
    //     url: `https://basemaps.linz.govt.nz/v1/tiles/bay-of-plenty-2024-0.2m/WebMercatorQuad/{z}/{x}/{y}.webp?api=${mapApi['key']}`
    //   })
    // }),
    //   new TileLayer({
    //   source: new XYZ({
    //     attributions: "Tauranga 2022 Winter Basemap: <a href=\"https://basemaps.linz.govt.nz\">&copy; CC BY 4.0 LINZ</a>",
    //     url: `https://basemaps.linz.govt.nz/v1/tiles/tauranga-winter-2022-0.1m/WebMercatorQuad/{z}/{x}/{y}.webp?api=${mapApi['key']}`
    //   })
    // }),
    //   new TileLayer({
    //   source: new XYZ({
    //     attributions: "BoP 2023-2024 Basemap: <a href=\"https://basemaps.linz.govt.nz\">&copy; CC BY 4.0 LINZ</a>",
    //     url: `https://basemaps.linz.govt.nz/v1/tiles/bay-of-plenty-2023-2024-0.2m/WebMercatorQuad/{z}/{x}/{y}.webp?api=${mapApi['key']}`
    //   })
    // }),

      new TileLayer({
        source: new XYZ({
          attributions: "Basemap: <a href=\"https://basemaps.linz.govt.nz\">&copy; CC BY 4.0 LINZ</a>",
          url: process.env.VUE_APP_LOCAL === undefined ? `https://basemaps.linz.govt.nz/v1/tiles/aerial/EPSG:3857/{z}/{x}/{y}.jpg?api=${mapApi['key']}` : `/tiles/aerial/EPSG:3857/{z}/{x}/{y}.jpg`
        })
      })
    ]

    let map_view = new View({
      zoom: 6,
      center: [171.493133, -40.344153],
    })

    const autogeolocation = new Geolocation({
      // enableHighAccuracy must be set to true to have the heading value.
      trackingOptions: {
        enableHighAccuracy: true,
      },
      projection: 'EPSG:4326',
    });

    // el('track').addEventListener('change', function () {
    //   geolocation.setTracking(this.checked);
    // });

// handle geolocation error.
    autogeolocation.on('error', function (error) {
      autogeolocation.setTracking(false)
      console.error("Geolocation error", error)
    });

    const accuracyFeature = new Feature();
    autogeolocation.on('change:accuracyGeometry', function () {
      console.log("Accuracy", autogeolocation.getAccuracyGeometry())
      accuracyFeature.setGeometry(autogeolocation.getAccuracyGeometry());
    });

    const positionFeature = new Feature();
    positionFeature.setStyle(
      new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: '#3399CC',
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 2,
          }),
        }),
      }),
    );
    const self = this
    autogeolocation.on('change:position', function () {
      const coordinates = autogeolocation.getPosition();
      console.log("Updated Position", coordinates) //, "was", self.geolocation)

      if (coordinates) {
        positionFeature.setGeometry(new Point(coordinates));
        if (!self.located) {
          map_view.fit(new Point(coordinates), {maxZoom: 17})
          console.log("Current KPIN: ", self.kpin, !self.kpin, "Overview Source", self.overviewSource, !!self.overviewSource)
          if (!self.kpin && self.overviewSource != null) {
            console.log("Auto-selecting orchard")
            self.overviewSource.forEachFeatureAtCoordinateDirect(coordinates, (feature) => {
              if (feature.get('acuris') === 'orchard') {
                const located_kpin = feature.get('kpin')
                console.log("Found orchard", located_kpin)
                for (let orchard of self.$root.orchards) {
                  if (orchard.kpin === located_kpin) {
                    self.$root.orchard = orchard
                    console.log("Selected orchard", orchard)
                    return true
                  }
                }
              }
            })
          }
          if (self.overviewSource != null) {
            console.log("Position Located")
            self.located = true
          }
        } else {
          console.log("Already located")
        }
        // self.geolocation = {position: coordinates}
      } else {
        positionFeature.setGeometry(null);
        // self.geolocation = null
      }
    });

    autogeolocation.on('change:tracking', function () {
      if (autogeolocation.getTracking()) {
        console.log("Tracking enabled")
        const coordinates = autogeolocation.getPosition();
        console.log("New Position", coordinates, autogeolocation.getProjection())
        positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
      } else {
        console.log("Tracking disabled")
        positionFeature.setGeometry(null);
        accuracyFeature.setGeometry(null);
        self.located = false
      }
    });

    this.map = new Map({
      target: this.$refs.map_root,
      layers: this.basemapLayers.reverse().concat([
        new VectorLayer({
          source: this.overviewSource,
          style: this.overviewObjectStyle,
          declutter: true,
        }),
        new VectorLayer({
          source: this.orchardSource,
          style: this.objectStyle,
          updateWhileAnimating: false,
          updateWhileInteracting: false,
          renderOrder: null
        }),
        new VectorLayer({
          source: new VectorSource({
            features: [accuracyFeature, positionFeature],
          }),
        })
      ]),

      // the map view will initially show NZ
      view: map_view,
      controls: controlDefaults({
            attributionOptions: {collapsible: true},
            zoomOptions: {delta: 0.5}
          }
      ).extend([
        new ScaleLine({bar: true})
      ]).extend(process.env.VUE_APP_LOCAL === undefined ?[
        new LocateControl({geolocation: autogeolocation}),
        new OpenMapControl({orchard_map: self})
      ] : [])
    })
    this.map.on('pointermove', (event) => {
      let features = this.map.getFeaturesAtPixel(event.pixel);
      this.$emit('update:hovered', features)
    })

    const select = new Select({
      filter(f) {
        return f.get('acuris') === 'bay'
      },
      style: this.selectedObjectStyle,
      toggleCondition: never
    })

    select.on('select', function (event) {
      console.debug("Selected", event.selected)
      component.$emit('update:selected', event.selected)
    })
    this.map.addInteraction(select)

    this.marker = new Overlay({
      positioning: 'center-center',
      element: this.$refs.geolocation_marker,
      stopEvent: false,
      autoPan: false,
    });
    this.map.addOverlay(this.marker);
  },
}
</script>

<template>
  <div>
    <div ref="map_root" style="width: 100%; height: 100vh"/>
    <img src="/img/icons/geolocation_marker.png" alt="Current Location" ref="geolocation_marker" />
    <div class="prompt block-prompt" v-if="!company || !kpin">
      <h4>No Orchard Selected.</h4>
      <span>Choose an orchard and a scan from the menus at the top.</span>
    </div>
  </div>
</template>

<style>
.tracking svg {
  fill: deepskyblue;
}
.locate-me {
  bottom: 80px;
  right: .5em;
}
.ol-touch .locate-me {
  top: 65px;
  left: .5em;
  bottom: unset;
  right: unset;
}

.open-map {
  bottom: 124px;
  right: .5em;
}
.ol-touch .open-map {
  top: 109px;
  left: .5em;
  bottom: unset;
  right: unset;
}
</style>

<style scoped>

.prompt {
  position: absolute;
  text-align: center;

  background-color: lightgray;
  border-radius: 0.5em;
  padding: 0.5rem 1rem 1rem 1rem;
}

.prompt h4 {
  margin-top: 16px;
}

.prompt.block-prompt {
  top: calc(50% - 4rem);
  /* right: calc(50% - 17rem); */
  right: calc(50% - 15rem);
}


@media (max-aspect-ratio: 1/1) {
/* @media (max-aspect-ratio: 8/5) and (min-aspect-ratio: 1/1) { */
  .prompt {
    position: absolute;
    text-align: center;

    background-color: lightgray;
    border-radius: 0.5em;
    padding: 0.5rem 1rem 1rem 1rem;
  }

  .prompt h4 {
    margin-top: 12px;
  }
  .prompt.block-prompt {
    /* top: calc(50% - 2rem); */
    right: calc(50% - 9rem);
    max-width: 18rem;
  }
}
</style>
